import { useSelector } from "react-redux";
import { selectTrainingLocalizationState } from "../app/slices/TrainingLocalizationSlice";
import LocalizedLanguageDTO, {
  LocalizedLanguageEntryDTO,
} from "../dto/LocalizedLanguageDTO";

export const UseSerializeLocalization = () => {
  const locState = useSelector(selectTrainingLocalizationState);

  const getMergedKeys = () =>
    Array.from(
      new Set([
        ...Object.keys(locState.localizedEntries),
        ...Object.keys(locState.propLocalizedEntries),
      ])
    );

  const getEntry = (key: string, shortcode: string) =>
    locState.propLocalizedEntries[key]?.[shortcode] ??
    locState.localizedEntries[key]?.[shortcode];

  const serializeLanguage = (shortcode: string) => {
    const entries: LocalizedLanguageEntryDTO[] = getMergedKeys().map((key) => {
      const localizedEntry = getEntry(key, shortcode);
      return {
        key,
        value: localizedEntry?.value ?? "",
        isAutoTranslated: localizedEntry?.isAutoTranslated ?? false,
      };
    });

    const dto: LocalizedLanguageDTO = {
      lang: shortcode,
      entries,
    };

    return dto;
  };

  const serializeLanguageForTesting = (shortcode: string) => {
    const entries: LocalizedLanguageEntryDTO[] = getMergedKeys().map((key) => {
      const localizedEntry = getEntry(key, shortcode);
      const value = localizedEntry?.value ?? "";
      return {
        key,
        value: value !== "" ? value : " ",
        isAutoTranslated: localizedEntry?.isAutoTranslated ?? false,
      };
    });

    const dto: LocalizedLanguageDTO = {
      lang: shortcode,
      entries,
    };

    return dto;
  };

  return { serializeLanguage, serializeLanguageForTesting } as const;
};
